import { createSelector } from '@reduxjs/toolkit';
import { getTermValue } from '../../../packages/JsonQuery';
import { selectJsonQuery } from './selectJsonQuery';

export const selectRentTime = createSelector(selectJsonQuery, jsonQuery => getTermValue('for_day')(jsonQuery));
